import React from 'react';
import PropTypes from 'prop-types';
import styles from './BuilderInfo.scss';

const propTypes = {
  lastSaved: PropTypes.string,
};

const defaultProps = {
  lastSaved: undefined,
};

const BuilderInfo = ({ lastSaved }) => {
  if (!lastSaved) {
    return null;
  }

  return (
    <div className={styles.info}>
      <div>Last saved:</div>
      <div>{lastSaved}</div>
    </div>
  );
};

BuilderInfo.propTypes = propTypes;
BuilderInfo.defaultProps = defaultProps;

export default BuilderInfo;
